module.exports = __webpack_public_path__ + "img/623622_A1756F_986353_89645B-256px.f541bc9e.png";